import {System} from '@fantasmagames/core/src/System';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {GameResourceLoader} from 'src/GameResourceLoader';
import {Device} from '@fantasmagames/core/src/device/Device';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class GameSystem extends System {
	protected createResourceLoader(getBaseUrlPath: Function): ResourcesLoader {
		return new GameResourceLoader(this.device, getBaseUrlPath, this.getLocale(), this._majorCaveatPerformance);
	}

	protected isSupportedDeviceAndBrowser(device: Device): boolean {
		let deviceIsSupported = true;

		if (deviceIsSupported && device.isMobile && device.isOppoBrowser) {
			deviceIsSupported = false;
		}

		return deviceIsSupported;
	}

	protected setupReelConstants(): void {
		ReelConstants.setReelsAmount(5);
		ReelConstants.setRowAmount(3);
	}

	protected getCurrencyISO(): string {
		this._currencyFormatter.setupCurrencyFromISO(this.urlParams
		&& this.urlParams.currency
			? this.urlParams.currency : 'USD');

		return this.urlParams && this.urlParams.currency ? this.urlParams.currency : 'USD';
	}
}



// WEBPACK FOOTER //
// ./src/GameSystem.ts